import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { LinkButton } from '@/shared/ui';

import styles from './LandingPage.module.css';

const features = ['budget', 'forecast', 'fsrs', 'source'] as const;

/**
 * What a visitor sees instead of a sign-in form: what the product does
 * differently, in four claims that are all true today, and two ways in.
 */
export function LandingPage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <h1 className={styles.title}>{t('landing.title')}</h1>
        <p className={styles.lead}>{t('landing.lead')}</p>
        <div className={styles.actions}>
          <LinkButton to="/register" variant="primary" className={styles.cta}>
            {t('landing.register')}
          </LinkButton>
          <LinkButton to="/login" className={styles.cta}>
            {t('landing.login')}
          </LinkButton>
        </div>
      </section>

      <ul className={styles.features}>
        {features.map((feature) => (
          <li key={feature} className={styles.feature}>
            <h2>{t(`landing.features.${feature}.title`)}</h2>
            <p>{t(`landing.features.${feature}.text`)}</p>
          </li>
        ))}
      </ul>

      <p className={styles.footer}>
        <Link to="/privacy">{t('landing.privacy')}</Link>
        <Link to="/terms">{t('landing.terms')}</Link>
      </p>
    </div>
  );
}
